//React
import { FunctionComponent, useEffect } from "react";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectPageOfMatchedResults } from "../../redux/selectors/pagination/select-page-of-matched-results";
import { selectIsMobile } from "../../../system/redux/selectors/select-is-mobile";
import { selectIsQmiFinder } from "../../../system/redux/selectors/select-is-qmi-finder";
import { selectRteApiData } from "../../redux/selectors/rte/select-rte-api-data";
import { selectAreaIsState } from "../../../area-info/redux/selectors/select-area-is-state";

//Components
import ResultCard from "./result-card";
import ResultCardQmi from "./result-card-qmi";
import ResultListPager from "../pagination/result-pager";
import HOTWTile from "./hotw-tile";

//Util
import { useLocalStorage } from "react-use";
import { selectAllResults } from "../../redux/selectors/select-all-results";
import RteCard from "./rte-card";
import HOTWCard from "./hotw-card";
import { selectShowHotwCard } from "../../redux/selectors/hotw/select-show-hotw-card";
import { useMediaQuery } from "react-responsive";
import NoResultCard from "./no-result-card";

interface ResultProps {}

const ResultList: FunctionComponent<ResultProps> = (props) => {
	const isQmiFinder = useAppSelector(selectIsQmiFinder);
	const rteApiData = useAppSelector(selectRteApiData);
	const areaIsState = useAppSelector(selectAreaIsState);

	//State Values
	const currentPageOfResults = useAppSelector(selectPageOfMatchedResults);
	const allResults = useAppSelector(selectAllResults);
	const showHotwCard = useAppSelector(selectShowHotwCard);

	const [localStorageResults, setLocalStorageResults] = useLocalStorage(
		"results",
		[],
	);

	const listType = isQmiFinder ? 'list-view qmi-list' : 'list-view';

	//Add the current results to local storage so the top search box local search works.
	useEffect(() => {
		let resultArrayForSearchbox = [];
		allResults.forEach((result) => {
			resultArrayForSearchbox.push(
				JSON.stringify({
					title: result.title + " " + result.address,
					url: result.url,
				}),
			);
		});

		setLocalStorageResults(resultArrayForSearchbox);
		window.dispatchEvent(new Event("storage"));
	}, [allResults]);

	//JSX
	if (currentPageOfResults?.length === 0 && !isQmiFinder) {
		return <div>Sorry, we don't have any homes matching your search.</div>;
	}
	else if (currentPageOfResults?.length === 0 && isQmiFinder) {
		return (
			<div className="list-view qmi-list">
				<NoResultCard />
			</div>
	);
	}

	return (
		<div className="community-set__results returned-results panel">
			<div
				className="community-set__tab-panel js-tab-panel"
				id="communityPanel"
				role="tabpanel"
				aria-hidden="false"
			>
				<div className="results-set">
					<div className="coveo-results-column">
						<section className={listType}>
							<div className="CoveoCustomResultList CoveoResultList">
								{isQmiFinder && currentPageOfResults?.length > 0 &&
									<HOTWTile key="hotw-tile" />
								}
								<div
									className="coveo-result-list-container coveo-list-layout-container"
									role="list"
								>
									{currentPageOfResults?.map((result, index) =>
										(index as number) == 0 ? (
											<>
												{!isQmiFinder ? 
													<ResultCard
														key={result.uniqueId}
														result={result}
														isInInfoWindow={false}
													/> : 
													<ResultCardQmi
														key={result.uniqueId}
														result={result}
														isInInfoWindow={false}
													/>
												}

												{showHotwCard && !isQmiFinder && !areaIsState && rteApiData.status != "live" && rteApiData.status != "teaser" && (
													<HOTWCard key="hotw-card" />
												)}

												<RteCard key="rte-card" />
											</>
										) : (
											<>
												{!isQmiFinder ? <ResultCard
													key={result.uniqueId}
													result={result}
													isInInfoWindow={false}
												/> : <ResultCardQmi
													key={result.uniqueId}
													result={result}
													isInInfoWindow={false}
												/>}
											</>
										),
									)}

									{currentPageOfResults?.length < 4 && currentPageOfResults?.length > 0 && isQmiFinder &&
										<NoResultCard />
									}

									<ResultListPager />
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResultList;
